import { createFileRoute } from '@tanstack/react-router';
import PageWrapper from 'src/components/PageWrapper/PageWrapper';

export const Route = createFileRoute('/user/password')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <PageWrapper title="Reset your password" description="Reset your password">
      <div>Hello "/user/password"!</div>
    </PageWrapper>
  );
}
